export default __webpack_public_path__ + "static/media/pytorch-icon.9189bc89.svg";